import { Select, SelectProps } from '@arco-design/web-react';
import React from 'react';

type Props = {
  display?: [string, string];
} & SelectProps;

export function SelectOppositeOption({
  value,
  onChange,
  placeholder = '全部',
  display = ['是', '否'],
}: Props) {
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      options={display.map((item, index) => ({
        label: item,
        value: index + 1,
      }))}
      allowClear
    />
  );
}
